import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaBell, FaMoneyBillWave } from "react-icons/fa";
import "../style/CustomerDetails.css";

function CustomerDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("Fetching customer details for ID:", id);
    
    const fetchCustomer = async () => {
      try {
        const response = await fetch(`http://localhost:8085/api/v1/customers/${id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        
        if (!response.ok) {
          throw new Error(`Failed to fetch customer! Status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log("API Response Data:", data);
        // If your API wraps data inside an object like { data: {...} }
        const result = data?.data ?? data;
        console.log("Processed Customer Data:", result);
        setCustomer(result);
      } catch (error) {
        console.error("Error fetching customer:", error);
        toast.error("Failed to load customer details");
      } finally {
        setLoading(false);
      }
    };
    
    fetchCustomer();
  }, [id]);

  if (loading) {
    return (
      <div className="container mt-5">
        <h3>Loading customer details...</h3>
      </div>
    );
  }

  if (!customer) {
    return (
      <div className="container mt-5">
        <h3>No customer found!</h3>
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }

return (
  <div className="challan-container">
    <div className="challan-card">

      {/* Header */}
      <div className="challan-header">
        <div className="challan-header-left">
          <div className="challan-avatar">
            {customer.name?.charAt(0).toUpperCase()}
          </div>
          <div className="challan-details">
            <h2 className="challan-title">Customer Details</h2>
            <span className="challan-subtitle">
              Profile & Account Information
            </span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="details-grid">
        <div className="detail-box">
          <div className="detail-icon">
            <FaUser />
          </div>
          <div className="detail-content">
            <label>Customer ID</label>
            <span>{customer.id}</span>
          </div>
        </div>

        <div className="detail-box">
          <div className="detail-icon">
            <FaUser />
          </div>
          <div className="detail-content">
            <label>Name</label>
            <span>{customer.name}</span>
          </div>
        </div>

        <div className="detail-box">
          <div className="detail-icon">
            <FaPhone />
          </div>
          <div className="detail-content">
            <label>Mobile</label>
            <span>{customer.contactNumber}</span>
          </div>
        </div>

        <div className="detail-box">
          <div className="detail-icon">
            <FaEnvelope />
          </div>
          <div className="detail-content">
            <label>Email</label>
            <span>{customer.email}</span>
          </div>
        </div>

        <div className="detail-box">
          <div className="detail-icon">
            <FaMapMarkerAlt />
          </div>
          <div className="detail-content">
            <label>Address</label>
            <span>{customer.address}</span>
          </div>
        </div>

        <div className="detail-box">
          <div className="detail-icon">
            <FaMoneyBillWave />
          </div>
          <div className="detail-content">
            <label>Balance</label>
            <span className="deposit">₹ {customer.runningBalance || 0}</span>
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="button-bar">
        <button className="btn-outlined" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>

    </div>
  </div>
);
}
export default CustomerDetails;
